module.exports = __webpack_public_path__ + "img/password.d0a1b5e2.svg";